export default __webpack_public_path__ + "static/media/OTP_Verify_BG.cd205449.png";